import * as React from 'react';
import { LoadOptions } from 'ui';

export interface OptionsCategoryFilterProps {
  categoryId: number;
  children?: React.ReactNode;
}

/**
 * Adds the passed in categoryId prop as an option in calls to onLoadOptions.
 */

export const withOptionCategorySupport = <P extends { onLoadOptions?: (loadOptions: LoadOptions) => void }>(
  WrappedComponent: React.ComponentClass<P>
): React.ComponentClass<P & OptionsCategoryFilterProps> => {
  return class extends React.Component<P & OptionsCategoryFilterProps> {
    private onLoadOptions = (options: LoadOptions): void => {
      if (this.props.onLoadOptions) {
        this.props.onLoadOptions({ categoryId: this.props.categoryId, ...options });
      }
    };

    public render() {
      return <WrappedComponent {...this.props} {...{onLoadOptions: this.onLoadOptions}} />;
    }
  };
};
